/** @format */

import { ArrowUpIcon } from "@heroicons/react/solid";
import React from "react";

export default function ScrollToTop() {
  const handelScrollTop = () => {
    document.getElementById("top-view").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-aos="fade-up"
      onClick={handelScrollTop}
      className="cursor-pointer  dark:text-white fixed left-5 z-30 bottom-10  "
    >
      <ArrowUpIcon className="h-10 w-10" />
    </div>
  );
}

